import React from 'react';
import FitSizeGuide from 'components/commercetools-ui/organisms/guides/fit-size';

const FitSizeGuideTastic = () => {
  return <FitSizeGuide />;
};

export default FitSizeGuideTastic;
